import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as insight360Actions from '../../../actions/insight360Actions';
import { ATTITUDE_ICON_LIST } from '../../../constants';

const getImageIcon = imageKey => {
  let selectedIcon;
  const imageComponent = _.find(ATTITUDE_ICON_LIST, { id: imageKey });
  if (imageComponent !== undefined) {
    selectedIcon = imageComponent.selectedIcon;
  }
  return selectedIcon;
};

const renderDeepDiveSlider = (value, personaIndex, categoryName,
  selectedTab, displayDeepDiveSlider) => {
  const deepDivePersonaObject = {
    personaIndex,
    category: categoryName,
    section: 'Attitudes',
    selectedTab,
  };
  displayDeepDiveSlider(value, deepDivePersonaObject);
};

const AttitudeComparisionDetail = ({
  selectedIcon,
  categoryName,
  statement,
  attitudeDetail,
  personaIndex,
  selectedTab,
  displayDeepDiveSlider,
}) => (<div>
  {categoryName !== undefined &&
    statement !== undefined &&
    attitudeDetail !== undefined && (<div className="attitude-detail-comparision-grid">
      <div
        className="attitude-comparision-float pointer-cursor"
        onClick={() => {
          renderDeepDiveSlider(true, personaIndex,
            categoryName, selectedTab, displayDeepDiveSlider);
        }}
      >
        <div className="attitude-float">
          <div
            className="attitude-comparision-image-border attitude-float"
            id="attitude-comparision-image-border-pdf"
          >
            {getImageIcon(selectedIcon) ===
              undefined && <div className="imageblock" />}
            {getImageIcon(selectedIcon) !==
              undefined && (<img
                className="i360-demo-double-comparision-img"
                src={getImageIcon(selectedIcon)}
                alt={categoryName}
              />
              )}
            <div className="attitude-comparision-icon-labels">
              {categoryName}{' '}
            </div>
          </div>
        </div>
        <div>
          <div
            className="div-overflow"
            id="attitudeComparisionLabelheight"
          >
            <div
              className="attitude-comparision-labels"
              id="pdfAttituteLabels"
              title={statement}
            >
              <p className="block-with-text">{statement}</p>
            </div>
          </div>
          <div className="div-overflow">
            <div className="attitude-triple-comparision-metrics">
              INDEX:&nbsp;&nbsp;
              {!_.isEmpty(attitudeDetail)
                ? attitudeDetail.index
                : 'N/A'}{' '}
              | REACH:&nbsp;&nbsp;
              {!_.isEmpty(attitudeDetail)
                ? attitudeDetail.pct
                : 'N/A'}{' '}
            </div>
          </div>
        </div>
      </div>
    </div>
    )}
</div>
  );

AttitudeComparisionDetail.propTypes = {
  selectedIcon: PropTypes.string,
  categoryName: PropTypes.string,
  statement: PropTypes.string,
  attitudeDetail: PropTypes.shape({}),
  displayDeepDiveSlider: PropTypes.func,
  personaIndex: PropTypes.number,
  selectedTab: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  const displayDeepDiveSlider = (value, deepDivePersonaObject) => {
    dispatch(insight360Actions.showDeepDivePopup(value, deepDivePersonaObject));
  };
  return {
    displayDeepDiveSlider,
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
)(AttitudeComparisionDetail);
